module.exports = __webpack_public_path__ + "media/fonts/fa-solid-900-6181554026ba3b2c51911370659ee3fe.woff2";